import api from '@/services/api'

/**
 * 获取年度企业所得税报表数据
 * @param {number} year 年份
 * @param {number} wholesalerId 批发商ID
 */
export function getAnnualIncomeTaxReport(year, wholesalerId) {
  return api.get(`/report/tax/income-tax/${year}`, {
    params: { wholesalerId }
  })
}

/**
 * 获取 GST 季度报表数据
 * @param {number} year 年份
 * @param {number} quarter 季度 (1-4)
 * @param {number} wholesalerId 批发商ID
 */
export function getGstQuarterlyReport(year, quarter, wholesalerId) {
  return api.get(`/report/tax/gst/${year}/${quarter}`, {
    params: { wholesalerId }
  })
}

/**
 * 导出企业所得税报表
 * @param {number} year 年份
 * @param {number} wholesalerId 批发商ID
 * @param {string} format 格式 (excel/pdf)
 * @param {string} lang 语言 (zh/en)
 */
export function exportIncomeTaxReport(year, wholesalerId, format = 'excel', lang = 'en') {
  return api.get(`/report/tax/income-tax/${year}/export`, {
    params: { wholesalerId, format, lang },
    responseType: 'blob'
  })
}

/**
 * 导出 GST 报表
 * @param {number} year 年份
 * @param {number} quarter 季度
 * @param {number} wholesalerId 批发商ID
 * @param {string} format 格式 (excel/pdf)
 * @param {string} lang 语言 (zh/en)
 */
export function exportGstReport(year, quarter, wholesalerId, format = 'excel', lang = 'en') {
  return api.get(`/report/tax/gst/${year}/${quarter}/export`, {
    params: { wholesalerId, format, lang },
    responseType: 'blob'
  })
}

// ========== 税务历史数据 ==========

export function getTaxHistoricalData(wholesalerId, year, quarter = null) {
  const params = { wholesalerId, year }
  if (quarter) params.quarter = quarter
  return api.get('/report/tax/historical', { params })
}

export function createTaxHistoricalData(data) {
  return api.post('/report/tax/historical', data)
}

export function updateTaxHistoricalData(id, data) {
  return api.put(`/report/tax/historical/${id}`, data)
}

export function deleteTaxHistoricalData(id) {
  return api.delete(`/report/tax/historical/${id}`)
}
